import React, { useEffect, useMemo, useState } from "react";
import {
  Badge,
  Card,
  CardBody,
  UncontrolledTooltip,
} from "reactstrap";
import TableContainer from "../../../components/Common/TableContainer";
import EcommerceOrdersPaymentModal from "../../Ecommerce/EcommerceOrders/EcommerceOrdersPaymentModal";

const Address = ({ userId }) => {
  
  
  const baseurl = process.env.REACT_APP_BASE_URL;
  const imgurl = process.env.REACT_APP_IMAGE_URL;

  const [AddressData, setAddressData] = useState([]);
  const [pagination, setPagination] = useState({});
  const [loading, setLoading] = useState(true);
  const [paymentDetailsModal, setPaymentDetailsModal] = useState(false);

  // 🔹 Fetch Cart Data
  useEffect(() => {
    const fetchAddress = async () => {
      try {
        setLoading(true);
        const res = await fetch(`${baseurl}/admin/customer/individuals/address/${userId}`);
        const data = await res.json();

        if (data.success) {
          setAddressData(data.data);
          setPagination(data.pagination);
        } else {
          setAddressData([]);
        }
      } catch (err) {
        console.error("Fetch carts error:", err);
      } finally {
        setLoading(false);
      }
    };

    if (userId) fetchAddress();
  }, [userId, baseurl]);

  // 🔹 Modal toggle
  const togglePaymentDetailsViewModal = () =>
    setPaymentDetailsModal(!paymentDetailsModal);

  // 🔹 Define Table Columns
  const columns = useMemo(
    () => [
      {
        Header: "ID",
        accessor: "id",
        Cell: ({ value }) => <div className="text-body fw-bold">{value}</div>,
      },
      {
        Header: "Full Name",
        accessor: "full_name",
        Cell: ({ value }) => <div className="text-body fw-bold">{value}</div>,
      },
      {
        Header: "Mobile No",
        accessor: "mobile_no",
        Cell: ({ value }) => (
           <div className="text-body">{value}</div>
        ),
      },
      {
        Header: "Email",
        accessor: "email_address",
        Cell: ({ value }) =>
          <div className="text-body">{value}</div>
      },
      {
        Header: "Address",
        accessor: "address",
        Cell: ({ value }) =>
          <div className="text-body">{value}</div>
      },{
        Header: "Address 1",
        accessor: "address1",
        Cell: ({ value }) =>
          <div className="text-body">{value}</div>
      },{
        Header: "City",
        accessor: "city",
        Cell: ({ value }) =>
          <div className="text-body">{value}</div>
      },{
        Header: "State",
        accessor: "state",
        Cell: ({ value }) =>
          <div className="text-body">{value}</div>
      },{
        Header: "Pincode",
        accessor: "pincode",
        Cell: ({ value }) =>
          <div className="text-body">{value}</div>
      },{
        Header: "Delivery Instruction",
        accessor: "delivery_instruction",
        Cell: ({ value }) =>
          <div className="text-body">{value}</div>
      },{
        Header: "Default",
        accessor: "is_default",
        Cell: ({ value }) =>
          <div className="text-body">{value}</div>
      },
      // {
      //   Header: "Action",
      //   accessor: "action",
      //   disableFilters: true,
      //   Cell: ({ row }) => {
      //     const { cart_no, status } = row.original;
      //     const isExpired = status === "Expired";
      //     return (
      //       <div className="d-flex gap-3 align-items-center">
      //         <Link
      //           to="#"
      //           className="text-success"
      //           onClick={togglePaymentDetailsViewModal}
      //         >
      //           <i className="mdi mdi-eye-outline font-size-18" id={`view-${id}`} />
      //           <UncontrolledTooltip placement="top" target={`view-${id}`}>
      //             View Cart
      //           </UncontrolledTooltip>
      //         </Link>

      //         <Link
      //           to={`/manage-request/cart/individual-customers/cart-list/${id}`}
      //           className={`text-success ${isExpired ? "disabled-link" : ""}`}
      //           aria-disabled={isExpired}
      //         >
      //           <i className="mdi mdi-pencil font-size-18" id={`edit-${id}`} />
      //           <UncontrolledTooltip placement="top" target={`edit-${id}`}>
      //             Edit Cart
      //           </UncontrolledTooltip>
      //         </Link>
      //       </div>
      //     );
      //   },
      //},
    ],
    []
  );

  if (loading)
    return (
      <div className="text-center py-5">
        <div className="spinner-border text-secondary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );

  return (
    <>
        <h5 className="mb-3">
            Address List{" "}
            <Badge color="secondary" pill>
              {pagination.total || 0}
            </Badge>
          </h5>

          {AddressData.length > 0 ? (
            <TableContainer
              columns={columns}
              data={AddressData}
              isGlobalFilter={false}
              customPageSize={10}
              className="custom-header-css"
            />
          ) : (
            <p className="text-muted text-center">No cart data available.</p>
          )}
        

      <EcommerceOrdersPaymentModal
        isOpen={paymentDetailsModal}
        toggle={togglePaymentDetailsViewModal}
      />
    </>
  );
};

export default Address;
